import { Button } from '@mui/material';
import { buttonsStyle } from './styles';
import { Colors, FindLoad, Images } from 'utils';
import { MinLoader } from '../loader';

export const AddButton = ({ addButtonClassName, disabled, styles, text, handleClick, type, Icon, customIcon }) => {
    const classes = buttonsStyle();
    const loader = FindLoad(type);

    return (
        <Button
            id={text ? text.replace(/\s+/g, '') + 'Btn' : 'defaultAddBtn'}
            disabled={disabled || loader?.length}
            style={{ background: !disabled ? `#347AF0` : 'rgba(52,122,240,.5)', ...styles }}
            className={`${classes.addButtonStyle} ${addButtonClassName}`}
            onClick={handleClick}
        >
            {Icon !== false && !loader?.length && <img src={customIcon ? customIcon : Images.addCircle} alt={'icon'} />}

            {loader?.length ? <MinLoader margin={'0'} color={Colors.TextWhite} /> : text}
        </Button>
    );
};
